var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { InputItem, List, Toast } from 'antd-mobile';
import { Field, Formik } from 'formik';
import React, { Component } from 'react';
import { ErrorCode, px2rem, trimPhoneNumber, validatePhoneFormat } from 'smartpi-core';
import styled from 'styled-components';
import { Container } from 'typedi';
import { h5AuthApiClient } from '../services/api';
import { AuthManager } from '../services/auth';
import { UserManager } from '../services/user';
var MainContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 100vh;\n  min-height: ", ";\n  position: relative;\n  overflow: hidden;\n  background: rgba(0, 0, 0, 1);\n  opacity: 0.7;\n"], ["\n  height: 100vh;\n  min-height: ", ";\n  position: relative;\n  overflow: hidden;\n  background: rgba(0, 0, 0, 1);\n  opacity: 0.7;\n"])), px2rem(1200));
var MainContent = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  margin-left: ", ";\n  margin-top: ", ";\n  width: ", ";\n  height: ", ";\n  background: white;\n  border-radius: ", ";\n"], ["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  margin-left: ", ";\n  margin-top: ", ";\n  width: ", ";\n  height: ", ";\n  background: white;\n  border-radius: ", ";\n"])), px2rem(-320), px2rem(-260), px2rem(640), px2rem(520), px2rem(20));
var CellphoneInput = styled.input(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: 100%;\n  height: ", ";\n  border-radius: 36px;\n  border: none;\n  font-size: ", ";\n  color: #666;\n  text-align: center;\n  box-sizing: border-box;\n  padding: 0 ", ";\n"], ["\n  width: 100%;\n  height: ", ";\n  border-radius: 36px;\n  border: none;\n  font-size: ", ";\n  color: #666;\n  text-align: center;\n  box-sizing: border-box;\n  padding: 0 ", ";\n"])), px2rem(88), px2rem(28), px2rem(20));
var VerifyCodeInput = styled(CellphoneInput)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  text-align: left;\n"], ["\n  text-align: left;\n"])));
var InputContainer = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  position: relative;\n  padding-bottom: ", ";\n"], ["\n  position: relative;\n  padding-bottom: ", ";\n"])), px2rem(250));
var ExtraItemButton = styled('button')(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  border: none;\n  border-radius: 36px;\n  position: absolute;\n  right: ", ";\n  top: ", ";\n  font-size: 14px;\n  height: 89%;\n  width: ", ";\n  padding: 1px 10px 2px;\n  box-sizing: border-box;\n  :active {\n    color: white;\n    background-color: #f24416;\n  }\n  ", ";\n"], ["\n  border: none;\n  border-radius: 36px;\n  position: absolute;\n  right: ", ";\n  top: ", ";\n  font-size: 14px;\n  height: 89%;\n  width: ", ";\n  padding: 1px 10px 2px;\n  box-sizing: border-box;\n  :active {\n    color: white;\n    background-color: #f24416;\n  }\n  ", ";\n"])), px2rem(5), px2rem(6), px2rem(200), function (props) { return (props.active ? "background-color: #FF8D67;color: #FFC6B3;" : "background-color: #FF5F2A ;color: white;"); });
var ConfirmButton = styled.button(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  display: inline-block;\n  width: 100%;\n  height: ", ";\n  border-radius: 22px;\n  color: #3691ff;\n  text-align: center;\n  border: none;\n  background-color: #ff5f2a;\n  color: white;\n  font-size: 16px;\n  :active {\n    color: white;\n    background-color: #f24416;\n  }\n"], ["\n  display: inline-block;\n  width: 100%;\n  height: ", ";\n  border-radius: 22px;\n  color: #3691ff;\n  text-align: center;\n  border: none;\n  background-color: #ff5f2a;\n  color: white;\n  font-size: 16px;\n  :active {\n    color: white;\n    background-color: #f24416;\n  }\n"])), px2rem(86));
var FormItem = styled(List)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  margin: ", " auto;\n  border-radius: 25px;\n  box-shadow: 10px 12px 20px 0px rgba(173, 83, 0, 0.1);\n  position: relative;\n  && {\n    img {\n      width: 18px;\n    }\n  }\n  div.am-list-body {\n    border-radius: 44px;\n    .am-list-item {\n      border-radius: 44px;\n    }\n    .am-input-label {\n      font-size: 14px;\n      width: 29px;\n      margin-right: 0;\n    }\n  }\n  .am-list-body::after {\n    border-radius: 44px;\n    background-color: transparent !important;\n  }\n  .am-list-body::before {\n    border-radius: 44px;\n    background-color: transparent !important;\n  }\n"], ["\n  width: ", ";\n  height: ", ";\n  margin: ", " auto;\n  border-radius: 25px;\n  box-shadow: 10px 12px 20px 0px rgba(173, 83, 0, 0.1);\n  position: relative;\n  && {\n    img {\n      width: 18px;\n    }\n  }\n  div.am-list-body {\n    border-radius: 44px;\n    .am-list-item {\n      border-radius: 44px;\n    }\n    .am-input-label {\n      font-size: 14px;\n      width: 29px;\n      margin-right: 0;\n    }\n  }\n  .am-list-body::after {\n    border-radius: 44px;\n    background-color: transparent !important;\n  }\n  .am-list-body::before {\n    border-radius: 44px;\n    background-color: transparent !important;\n  }\n"])), px2rem(560), px2rem(88), px2rem(36));
var CellphoneFormItem = styled(FormItem)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  margin-top: ", ";\n"], ["\n  margin-top: ", ";\n"])), px2rem(72));
var FormItemButton = styled(FormItem)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  margin: ", " auto;\n  box-shadow: 0px 10px 14px 0px rgba(232, 0, 0, 0.3);\n  /* .am-list-body {\n    .am-list-item {\n      padding: 0;\n      background-color: #ff5f2a;\n      .am-list-line {\n        padding: 0;\n      }\n      .am-list-content {\n        border-radius: 22px;\n        padding: 0;\n        width: 100%;\n        height: 100%;\n      }\n    }\n  } */\n"], ["\n  width: ", ";\n  height: ", ";\n  margin: ", " auto;\n  box-shadow: 0px 10px 14px 0px rgba(232, 0, 0, 0.3);\n  /* .am-list-body {\n    .am-list-item {\n      padding: 0;\n      background-color: #ff5f2a;\n      .am-list-line {\n        padding: 0;\n      }\n      .am-list-content {\n        border-radius: 22px;\n        padding: 0;\n        width: 100%;\n        height: 100%;\n      }\n    }\n  } */\n"])), px2rem(600), px2rem(86), px2rem(78));
var AuthCellphone = /** @class */ (function (_super) {
    __extends(AuthCellphone, _super);
    function AuthCellphone(props) {
        var _this = _super.call(this, props) || this;
        _this.startRequestVerifyCodeCounter = function () {
            if (_this.state.verifyCodeTime === AuthCellphone.DEFAULT_VERIFY_CODE_TIME) {
                _this.setState({
                    verifyCodeTime: AuthCellphone.DEFAULT_VERIFY_CODE_TIME - 1,
                    requestVerificationCodeButtonText: _this.state.verifyCodeTime + " S",
                    isVerifyCodeCounter: true,
                });
                var verifyCodeTimeCounterId = setInterval(function () {
                    _this.setState({
                        verifyCodeTime: _this.state.verifyCodeTime - 1,
                        requestVerificationCodeButtonText: _this.state.verifyCodeTime + " S",
                    }, function () {
                        if (_this.state.verifyCodeTime < 0) {
                            _this.killRequestVerifyCodeCounter();
                            _this.setState({
                                verifyCodeTime: AuthCellphone.DEFAULT_VERIFY_CODE_TIME,
                                requestVerificationCodeButtonText: "\u91CD\u65B0\u83B7\u53D6",
                                isVerifyCodeCounter: false,
                            });
                        }
                    });
                }, 1000);
                _this.verifyCodeTimeCounterId = verifyCodeTimeCounterId;
            }
        };
        _this.requestVerificationCode = function (e, formData) { return __awaiter(_this, void 0, void 0, function () {
            var cellNumber, sendVerifyCodeResult, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        cellNumber = formData.cellNumber;
                        if (!validatePhoneFormat(cellNumber)) {
                            Toast.fail('请输入合法手机号码', 2);
                            return [2 /*return*/];
                        }
                        if (this.state.verifyCodeTime !== AuthCellphone.DEFAULT_VERIFY_CODE_TIME) {
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, h5AuthApiClient.requestCellphoneAuthVerifyCode(trimPhoneNumber(cellNumber))];
                    case 2:
                        sendVerifyCodeResult = _a.sent();
                        if (sendVerifyCodeResult) {
                            Toast.success('我们已将验证码发送到您的手机，请留意短信', 3);
                            this.startRequestVerifyCodeCounter();
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        Toast.fail('发送验证码失败，请稍后重试', 2);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        _this.submit = function (formData) { return __awaiter(_this, void 0, void 0, function () {
            var cellNumber, verificationCode, _a, user, token, e_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        cellNumber = formData.cellNumber, verificationCode = formData.verificationCode;
                        if (!validatePhoneFormat(cellNumber)) {
                            Toast.fail('请输入合法手机号码', 2);
                            return [2 /*return*/];
                        }
                        if (!verificationCode) {
                            Toast.fail('请输入验证码', 2);
                            return [2 /*return*/];
                        }
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, h5AuthApiClient.signInOrSignUpByCellphone(cellNumber, verificationCode)];
                    case 2:
                        _a = _b.sent(), user = _a.user, token = _a.token;
                        Container.get(AuthManager).setToken(token);
                        Container.get(UserManager).setUser(user);
                        // update user token
                        Toast.success('注册成功', 1);
                        if (this.props.onAuthSuccess) {
                            this.props.onAuthSuccess(user);
                        }
                        this.redirectToPreviousPage();
                        return [3 /*break*/, 4];
                    case 3:
                        e_2 = _b.sent();
                        if (e_2.response && e_2.response.data) {
                            switch (e_2.response.data.code) {
                                case ErrorCode.MOBILE_BOUND_BY_OTHER_USER:
                                case ErrorCode.USER_ALREADY_BOUND_MOBILE:
                                    Toast.success('该手机号已注册，请不要重复注册哦', 2);
                                    break;
                                case ErrorCode.INVALID_SMS_CODE:
                                    Toast.success('验证码错误', 2);
                                    break;
                                case ErrorCode.USER_ENROLLMENT_CONFLICT:
                                    Toast.success('存在同系列课程，请联系班主任退课后绑定', 2);
                                    break;
                                default:
                                    Toast.fail('绑定失败', 2);
                            }
                        }
                        else {
                            Toast.fail('绑定失败', 2);
                        }
                        if (this.props.onAuthError) {
                            this.props.onAuthError(e_2);
                        }
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        _this.state = {
            verifyCodeTime: 60,
            requestVerificationCodeButtonText: '获取验证码',
            isVerifyCodeCounter: false,
        };
        return _this;
    }
    AuthCellphone.prototype.componentWillUnmount = function () {
        if (this.verifyCodeTimeCounterId !== undefined) {
            this.killRequestVerifyCodeCounter();
        }
    };
    AuthCellphone.prototype.killRequestVerifyCodeCounter = function () {
        clearInterval(this.verifyCodeTimeCounterId);
    };
    AuthCellphone.prototype.redirectToPreviousPage = function () {
        var returnPathState = this.props.history.location.state;
        if (returnPathState && returnPathState.returnPath) {
            this.props.history.replace(returnPathState.returnPath);
        }
        else {
            this.props.history.replace('/');
        }
    };
    AuthCellphone.prototype.render = function () {
        var _this = this;
        var isVerifyCodeCounter = this.state.isVerifyCodeCounter;
        var registerBtnText = this.props.registerBtnText;
        return (React.createElement(MainContainer, null,
            React.createElement(MainContent, null,
                React.createElement(InputContainer, null,
                    React.createElement(Formik, { initialValues: { cellNumber: '', verificationCode: '' }, onSubmit: function (values) { return _this.submit(values); }, render: function (props) { return (React.createElement("form", { onSubmit: props.handleSubmit },
                            React.createElement(CellphoneFormItem, null,
                                React.createElement(Field, { name: "cellNumber", render: function (_a) {
                                        var field = _a.field;
                                        return React.createElement(CellphoneInput, __assign({}, field, { placeholder: "\u8BF7\u8F93\u5165\u624B\u673A\u53F7" }));
                                    } })),
                            React.createElement(FormItem, null,
                                React.createElement(Field, { name: "verificationCode", component: InputItem, type: "number", onChange: function (value) {
                                        props.values.verificationCode = value;
                                    }, placeholder: "\u624B\u673A\u9A8C\u8BC1\u7801", render: function (_a) {
                                        var field = _a.field;
                                        return (React.createElement(React.Fragment, null,
                                            React.createElement(VerifyCodeInput, __assign({}, field, { placeholder: "\u624B\u673A\u9A8C\u8BC1\u7801" })),
                                            React.createElement(ExtraItemButton, { active: isVerifyCodeCounter, type: "button", onClick: function (e) { return _this.requestVerificationCode(e, props.values); } }, _this.state.requestVerificationCodeButtonText)));
                                    } })),
                            React.createElement(FormItemButton, null,
                                React.createElement(ConfirmButton, { type: "submit" }, registerBtnText || '确定')))); } })))));
    };
    AuthCellphone.DEFAULT_VERIFY_CODE_TIME = 60;
    return AuthCellphone;
}(Component));
export { AuthCellphone };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;
//# sourceMappingURL=AuthCellphone.js.map


//////////////////
// WEBPACK FOOTER
// ../core-h5/build/src/components/AuthCellphone.js
// module id = 1132
// module chunks = 0